module.exports = "https://static.zego.com/_next/static/images/FreeNowLogo-669a7b21f983a3ba56e62d784e78ba40.svg";